import { render } from "./GenericTableFormPageTemplate.vue?vue&type=template&id=3af898aa"
import script from "./GenericTableFormPageTemplate.vue?vue&type=script&lang=js"
export * from "./GenericTableFormPageTemplate.vue?vue&type=script&lang=js"

import "./GenericTableFormPageTemplate.vue?vue&type=style&index=0&id=3af898aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__